import { Box, SxProps, Typography } from '@mui/material';
import React, { ReactNode } from 'react';

export interface FallbackProps {
  imgSrc: string;
  message: ReactNode;
  sx?: SxProps;
}

const Fallback = ({ imgSrc, message, sx = {} }: FallbackProps) => (
  <Box mt={9} display="flex" flexDirection="column" alignItems="center" gap={3} sx={sx}>
    <Box component="img" src={imgSrc} />
    {typeof message === 'string' ? <Typography color="text.secondary">{message}</Typography> : message}
  </Box>
);

export default Fallback;
